export enum HasBookingKitsFilter {
  True = "true",
  False = "false",
  MissingCompleteAndAccruedCost = "missing-complete-and-accrued-cost",
  MissingCompleteAndAccruedIncome = "missing-complete-and-accrued-income"
}
